import React from 'react'
import envelope from 'assets/envelope.svg'
import StageContent from '../common/StageContent'
import StageFooter from '../common/StageFooter'
import StageHeader from '../common/StageHeader'
import {useTranslation} from 'react-i18next'
import CodeInput from './components/CodeInput'
import StepProgressBar from 'features/common/components/StepProgressBar'
import {useTypedTranslation} from 'i18n'
import useEmailCode from '../../../common/hooks/useEmailCode/useEmailCode'

export const EmailStage = () => {
    const {t} = useTranslation()
    const {t: typedT} = useTypedTranslation()
    const {
        isSending,
        email,
        resendTimeout,
        send,
        check,
        codeInputValue,
        codeLength,
        onChangeCode,
        checkError,
    } = useEmailCode()

    const codeResendDisabled = isSending || resendTimeout > 0

    const checkErrorMessage =
        checkError instanceof Error ? checkError.message : ''

    return (
        <div className="flex flex-1 flex-col">
            <StageHeader>{t('ONBOARDING_STEP_EMAIL')}</StageHeader>
            <StageContent>
                <img src={envelope} alt="email confirmation" />
                <div className="text-2xl">
                    {`${t('ONBOARDING_EMAIL_DESCRIPTION')} ${email}`}
                </div>
                <div className="text-4xl font-bold text-yellow-30">
                    {t('ONBOARDING_ENTER_CODE')}
                </div>
                <CodeInput
                    onSubmit={check}
                    value={codeInputValue}
                    length={codeLength}
                    onChange={onChangeCode}
                />
                <button
                    className="text-right text-2xl font-bold text-yellow-30 disabled:text-yellow-20"
                    onClick={send}
                    disabled={codeResendDisabled}
                >
                    {t('ONBOARDING_SEND_CODE_AGAIN')} {resendTimeout || ''}
                </button>
                <div className="mb-3 text-4xl font-bold text-red-700">
                    {typedT(checkErrorMessage)}
                </div>
            </StageContent>
            <StageFooter>
                <StepProgressBar
                    points={[
                        {
                            title: t('ONBOARDING_STEP_REGISTRATION'),
                            status: 'success',
                        },
                        {title: t('ONBOARDING_STEP_EMAIL'), status: 'current'},
                        {title: t('ONBOARDING_STEP_STRIPE'), status: 'empty'},
                    ]}
                />
            </StageFooter>
        </div>
    )
}

export default EmailStage
